export default "__VITE_ASSET__28efd1d6__"